<template lang="html">
<div>

    <div class="subpage delcare5">
          <el-form ref="ruleForm" :model="params" :rules="rules" :show-message="false">
                <div class="text-block clearfix">
                    <div class="bName">产业方向</div>
                    <div class="bContent">
                         <el-form-item prop="policyTypeId">
                             <radio-select code="cyfx" :selectId="params.policyTypeId" paramsKey="policyTypeId" @selectChange="selectChange" />
                         </el-form-item>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">企业类型</div>
                    <div class="bContent">
                         <el-form-item prop="subjectType">
                            <radio-select code="qiylx" :selectId="params.subjectType" paramsKey="subjectType" @selectChange="selectChange" />
                         </el-form-item>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">营业收入</div>
                    <div class="bContent">
                        <div class="">
                          <el-form-item prop="operatingIncome1">
                                <el-input-number size="medium" v-model="params.operatingIncome1" :precision="2" label="请输入最小值（万元）"></el-input-number>
                          </el-form-item>
                          <span class="midspan">至</span>
                          <el-form-item prop="operatingIncome2">
                                <el-input-number size="medium" v-model="params.operatingIncome2" :precision="2" label="请输入最大值（万元）"></el-input-number>
                          </el-form-item>
                        </div>
                        <div class="tips">
                           请按照条件中的金额要求填写，如 120 万元至 150 万元，第一个填写金额最小范围，第二个填写金额最大范围
                        </div>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">企业利润</div>
                    <div class="bContent">
                        <div class="">
                          <el-form-item prop="corporateProfits1">
                                <el-input-number size="medium" v-model="params.corporateProfits1" :precision="2" label="请输入最小值（万元）"></el-input-number>
                          </el-form-item>
                          <span class="midspan">至</span>
                          <el-form-item prop="corporateProfits2">
                                <el-input-number size="medium" v-model="params.corporateProfits2" :precision="2" label="请输入最大值（万元）"></el-input-number>
                          </el-form-item>

                        </div>
                        <div class="tips">
                           请按照条件中的金额要求填写，如 120 万元至 150 万元，第一个填写金额最小范围，第二个填写金额最大范围
                        </div>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">科技经费支出</div>
                    <div class="bContent">
                          <div class="">
                            <el-form-item prop="technologyFunding1">
                                  <el-input-number size="medium" v-model="params.technologyFunding1" :precision="2" label="请输入最小值（万元）"></el-input-number>
                            </el-form-item>
                            <span class="midspan">至</span>
                            <el-form-item prop="technologyFunding2">
                                  <el-input-number size="medium" v-model="params.technologyFunding2" :precision="2" label="请输入最大值（万元）"></el-input-number>
                            </el-form-item>
                          </div>
                          <div class="tips">
                             请按照条件中的金额要求填写，如 120 万元至 150 万元，第一个填写金额最小范围，第二个填写金额最大范围
                          </div>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">人员规模</div>
                    <div class="bContent">
                          <el-form-item prop="numberOfParticipants">
                                <radio-select code="rygm" :selectId="params.numberOfParticipants" paramsKey="numberOfParticipants" @selectChange="selectChange" />
                          </el-form-item>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">知识产权</div>
                    <div class="bContent">
                          <el-form-item prop="intellectualProperty">
                                <radio-select code="zscq" :selectId="params.intellectualProperty" paramsKey="intellectualProperty" @selectChange="selectChange" />
                          </el-form-item>
                    </div>
                </div>

                <div class="text-block clearfix">
                    <div class="bName">发明专利</div>
                    <div class="bContent">
                         <el-form-item prop="patent">
                              <radio-select code="fmzllx" :selectId="params.patent" paramsKey="patent" @selectChange="selectChange" />
                         </el-form-item>
                    </div>
                </div>
          </el-form>
    </div>

</div>
</template>

<script>
import { decRulesGet } from "@/api/declare/declare";
export default {
    data(){
        return{

            params:{

                id:'',

                policyType:'',  // 产业方向
                policyTypeId:'',

                subjectType:'',  // 企业类型

                operatingIncome1:'',  // 营业收入
                operatingIncome2:'',

                corporateProfits1:'',  // 企业利润
                corporateProfits2:'',

                technologyFunding1:'',  // 科技经费支出
                technologyFunding2:'',

                numberOfParticipants:'',  // 人员规模

                intellectualProperty:'',  // 知识产权

                patent:'',  // 发明专利

            },

            rules:{}

        }
    },
    methods:{
         selectChange:function(e){
              this.params[e.paramsKey] = e.id;
         },
         saveReturn:function(){
             var vues = this;
             return new Promise((reslove,reject) => {
                 vues.$refs.ruleForm.validate((valid) => {

                     if(valid){
                         reslove(vues.params);
                     }else{
                         reslove(false);
                     }
                 })
             })
         },
         preSet:function(){

         }
    },
    mounted:function(){
        var querys = this.$route.query;
        var vues = this;

        if(querys.id){
            decRulesGet({cqjSbzcDeclarationPolicyId:querys.id}).then(res => {
                console.log(res);
                var unFromate = res.matchRuleList[0];
                for(var key in vues.params){
                    vues.params[key] = unFromate[key];
                }

            }).finally(function(){
                vues.$emit('inited');
            })
        }

    }
}
</script>

<style lang="scss" scoped>

.text-block{
      font-size: 14px;
     .bName{
          width: 90px;
          padding-top: 6px;
          float: left
     }
     .bContent{
          margin-left: 100px;
          position: relative;
          margin-bottom: 20px;
          .select-card{
               padding: 6px 15px;
               display: inline-block;
               border: 1px solid #efefef;
               color: #999999;
               margin-right: 20px;
               cursor: pointer;
          }

          .midspan{
              margin: 0 5px;
          }

          .select-card.act{
              color: salmon;
              border-color: salmon;
          }

          .tips{
              font-size: 12px;
              color: #AeAEAE;
              margin-top: 12px;
          }

     }

}

</style>

<style lang="css">

.subpage.delcare5 .el-input__inner{
  border-radius: 0px !important;
}

.subpage.delcare5 .el-input-number{
  width: 150px !important;
}

.subpage.delcare5 .el-form-item{
  display: inline-block !important;
  margin-bottom: 0px;
}

.subpage.delcare5 .radio-block .el-radio__label{
    padding-left: 5px !important;
}
</style>



// WEBPACK FOOTER //
// Subpage5.vue?634b6c26